import { Button } from '@olxbr/ds-web'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'

let mercurieComponent = null

export const renderChatClient = (props, container) => {
  mercurieComponent =
    ReactDOM.render(React.createElement(App, props), container)
  return mercurieComponent
}

export const isChatOpened = () => {
  if (mercurieComponent) {
    return mercurieComponent.isChatOpened()
  }
  console.warn('Failed to check if chat is opened. Assuming it is closed.')
  return false
}

if (process.env.NODE_ENV === 'development') {
  const localListId = localStorage.getItem('override-ListId')
  const defaultListId = process.env.REACT_APP_LIST_ID

  const localUserId = localStorage.getItem('override-BuyerId')
  const defaultUserId = process.env.REACT_APP_BUYER_ID

  mercurieComponent = ReactDOM.render(
    React.createElement(App, {
      listId: localListId || defaultListId,
      user: localUserId || defaultUserId,
      isAdview: true,
      ad: {
        adId: 1243045175,
        accountId: 107036953,
        // Usar o valor 2020 para testar o modal de leads
        category: 2021,
        price: 'R$ 26.0000',
        subject: 'Changan Ministar',
        user: {
          name: 'Teste',
          phone: '(31) 99999-9999',
          contatoPro: true
        },
      }
    }),
    document.getElementById('mercurie-app')
  )

  ReactDOM.render(
    React.createElement(
      Button,
      {
        children: 'Abrir chat',
        onClick: () => mercurieComponent.triggerOpenChat()
      }
    ),
    document.getElementById('mercurie-button')
  )
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()